import { render, staticRenderFns } from "./functionRole.vue?vue&type=template&id=3e496e23&scoped=true&"
import script from "./functionRole.vue?vue&type=script&lang=js&"
export * from "./functionRole.vue?vue&type=script&lang=js&"
import style0 from "./functionRole.vue?vue&type=style&index=0&id=3e496e23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e496e23",
  null
  
)

export default component.exports